import { render } from "./StandardButton.vue?vue&type=template&id=5f548030&scoped=true"
import script from "./StandardButton.vue?vue&type=script&lang=js"
export * from "./StandardButton.vue?vue&type=script&lang=js"

import "./StandardButton.vue?vue&type=style&index=0&id=5f548030&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f548030"]])

export default __exports__